import { createFileRoute, redirect } from '@tanstack/react-router'

import { URL_SUFFIX_INFO } from '@/core/constants/constants'

// Legacy `/course/:course/:theme/:topic/:lecture[/:suffix]` URLs predate the
// `/lectures` namespace; redirect them to the canonical lecture route.
export const Route = createFileRoute(
  '/_learning/course/$course/$theme/$topic/$lecture/{-$suffix}',
)({
  beforeLoad: ({ params: { topic, lecture, suffix } }) => {
    throw redirect({
      to: '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}',
      params: { topic, lecture, suffix: suffix ?? URL_SUFFIX_INFO },
    })
  },
})
